export const WAEC_DIGITAL_TECH = [];
